import React from "react"
import styled from "styled-components"
import {
  footerColor,
  accentPrimary,
  textColorLight,
  breakpointSmall,
} from "../variables"

const Footer = () => {
  return (
    <FooterContainer>
      <div className="top">
        <img src={"/footer-bg.svg"} alt="footer pattern" />
      </div>
      <div className="bottom">
        <p>copyright © {new Date().getFullYear()} by MahiPono</p>

        <div className="social">
          <a
            href="https://www.instagram.com/mahipono/?hl=en"
            title="Mahipono Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              id="instagram"
              xmlns="http://www.w3.org/2000/svg"
              width="18.011"
              height="18.01"
              viewBox="0 0 18.011 18.01"
            >
              <g
                id="Group_48"
                data-name="Group 48"
                transform="translate(-0.993 -0.993)"
              >
                <path
                  id="Path_100"
                  data-name="Path 100"
                  d="M10,5.32a4.645,4.645,0,1,0,.01,0Zm0,7.62a3,3,0,1,1,3-3A3,3,0,0,1,10,12.94Z"
                  fill="#fff"
                />
                <circle
                  id="Ellipse_4"
                  data-name="Ellipse 4"
                  cx="1.05"
                  cy="1.05"
                  r="1.05"
                  transform="translate(13.78 4.16)"
                  fill="#fff"
                />
                <path
                  id="Path_101"
                  data-name="Path 101"
                  d="M17.55,2.49A5.191,5.191,0,0,0,13.74,1H6.26A5,5,0,0,0,1,5.726,4.756,4.756,0,0,0,1,6.26V13.7a5.243,5.243,0,0,0,1.52,3.88A5.283,5.283,0,0,0,6.3,19h7.4a5.339,5.339,0,0,0,3.81-1.42A5.182,5.182,0,0,0,19,13.74V6.26A5.21,5.21,0,0,0,17.55,2.49Zm-.22,11.25a3.53,3.53,0,0,1-1,2.65,3.771,3.771,0,0,1-2.65.94H6.3a3.771,3.771,0,0,1-2.65-.94,3.668,3.668,0,0,1-1-2.69V6.26a3.642,3.642,0,0,1,1-2.65A3.722,3.722,0,0,1,6.3,2.67h7.47a3.632,3.632,0,0,1,2.65,1,3.718,3.718,0,0,1,1,2.61v7.48Z"
                  fill="#fff"
                />
              </g>
            </svg>
          </a>
          <a
            href="https://www.facebook.com/mahipono/"
            title="Mahipono Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              id="facebook"
              xmlns="http://www.w3.org/2000/svg"
              width="9.212"
              height="17.779"
              viewBox="0 0 9.212 17.779"
            >
              <path
                id="f"
                d="M29.789,30.341V22.267h2.729l.417-3.146H29.789V17.111c0-.91.265-1.554,1.554-1.554h1.668V12.714a23.9,23.9,0,0,0-2.426-.114,3.8,3.8,0,0,0-4.056,4.17v2.35H23.8v3.146h2.729v8.112h3.26Z"
                transform="translate(-23.8 -12.6)"
                fill="#fff"
              />
            </svg>
          </a>
        </div>
      </div>
    </FooterContainer>
  )
}

export default Footer

const FooterContainer = styled.footer`
  position: relative;

  .top {
    background: ${accentPrimary};
    position: relative;
    width: 100%;
    height: 427px;

    img {
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 1031.49px;
    }
  }

  .bottom {
    background: ${footerColor};
    color: ${textColorLight};
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-areas:
      ". copyright copyright copyright copyright ."
      ". . social social . .";
    place-items: center;
    padding: 32px 52px;

    p {
      font-size: 12px;
      font-weight: 400;
      margin: 0;
      grid-area: copyright;
      text-align: center;
    }

    .social {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      grid-area: social;

      #facebook {
        margin-left: 23px;
      }
    }
  }

  @media (min-width: ${breakpointSmall}) {
    .bottom {
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr;
      grid-template-areas: ". copyright social";
      place-items: center;

      p {
        font-size: 16px;
      }

      .social {
        justify-content: flex-end;
      }
    }
  }
`

